import React from 'react';
import PropTypes from 'prop-types';
import Idea from '../../Components/Idea';
import { Button } from '@salesforce/design-system-react';

const PotentialMilestones = (props) => {
  return (
    <React.Fragment>
      <div className="slds-grid slds-wrap slds-gutters slds-p-horizontal_xx-small">
        <div key="milestone-idea-button " className="slds-size_1-of-5 slds-col">
          <p className="grey-font slds-text-heading_medium page-block-header-title slds-align_absolute-center">Add Idea</p>
          <Button
            variant="brand"
            onClick={props.onButtonClick}
            className="slds-m-top_small slds-align_absolute-center add-idea-button"
          />
          
        </div>
        {Object.keys(props.ideas).map((ideaId) => {
          let idea = props.ideas[ideaId];
          return (
            <div key={idea.id} className="slds-size_1-of-5 slds-col slds-p-top_x-small">
              <Idea
                heading=""
                personaId={idea.personaId}
                milestone={props.milestone}
                chosen={idea.chosen}
                ideaContent={idea.ideaContent}
                id={idea.id}
                key={idea.id}
                onDropdownSelected={props.onDropdownSelected}
                openEditIdea={props.openEditIdea}
              />
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

PotentialMilestones.propTypes = {
  ideas: PropTypes.object.isRequired,
  milestone: PropTypes.string.isRequired,
  onDropdownSelected: PropTypes.func.isRequired,
};

export default PotentialMilestones;
